// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"86":"86849f28","131":"54a9d9ac","183":"cd014e56","592":"e6771eef"}[chunkId] + ".chunk.css";
};